import React from 'react';
import { useFormContext, useFieldArray } from 'react-hook-form';
import { Form, Row, Col, Button } from 'react-bootstrap';
import type { FormValues } from '../CustomerWizard';

const ContactStep: React.FC<{ allowPrimary?: boolean }> = ({ allowPrimary = true }) => {
  const { register, formState: { errors } } = useFormContext<FormValues>();
  const { fields, append, remove } = useFieldArray({
    name: 'contacts'
  });

  const handleAddContact = () => {
    append({
      contactType: 'EMAIL',
      contactValue: '',
      primary: false,
    });
  };

  return (
    <div className="contact-step">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4>Contact Information</h4>
        <Button variant="outline-primary" onClick={handleAddContact}>
          <i className="fa fa-plus me-2"></i>
          Add Contact
        </Button>
      </div>

      {fields.map((field, index) => (
        <div key={field.id} className="card mb-4">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 className="card-title mb-0">Contact {index + 1}</h5>
              <Button
                variant="outline-danger"
                size="sm"
                onClick={() => remove(index)}
              >
                <i className="fa fa-trash"></i>
              </Button>
            </div>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Contact Type</Form.Label>
                  <Form.Select
                    {...register(`contacts.${index}.contactType`)}
                    className={errors.contacts?.[index]?.contactType ? 'is-invalid' : ''}
                  >
                    <option value="EMAIL">Email</option>
                    <option value="SMS">SMS</option>
                    <option value="WHATSAPP">WhatsApp</option>
                    <option value="MOBILE">Mobile</option>
                  </Form.Select>
                  {errors.contacts?.[index]?.contactType && (
                    <Form.Control.Feedback type="invalid">
                      {errors.contacts[index]?.contactType?.message}
                    </Form.Control.Feedback>
                  )}
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Contact Value</Form.Label>
                  <Form.Control
                    type="text"
                    {...register(`contacts.${index}.contactValue`)}
                    className={errors.contacts?.[index]?.contactValue ? 'is-invalid' : ''}
                    placeholder="Enter email, phone number, etc."
                  />
                  {errors.contacts?.[index]?.contactValue && (
                    <Form.Control.Feedback type="invalid">
                      {errors.contacts[index]?.contactValue?.message}
                    </Form.Control.Feedback>
                  )}
                </Form.Group>
              </Col>
            </Row>

            {allowPrimary && <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Check
                    type="checkbox"
                    label="Primary Contact"
                    {...register(`contacts.${index}.primary`)}
                  />
                </Form.Group>
              </Col>
            </Row>}
          </div>
        </div>
      ))}

      {fields.length === 0 && (
        <div className="text-center py-5">
          <i className="fa fa-phone text-muted" style={{ fontSize: '3rem' }}></i>
          <p className="mt-3 text-muted">No contacts added yet</p>
          <Button variant="outline-primary" onClick={handleAddContact}>
            <i className="fa fa-plus me-2"></i>
            Add Contact
          </Button>
        </div>
      )}
    </div>
  );
};

export default ContactStep; 